// extracted by mini-css-extract-plugin
export default {"branchName":"ClosedOrMergedStateMergeBox-module__branchName--jGiSv"};